/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * Translation API
 * OpenAPI spec version: v3
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  TranslationControllerTranslatedAudioResult,
  TranslationControllerTranslationLanguage,
  TranslationRequest
} from './api-v3.schemas';

import { customAxiosInstance } from '../api/mutator';

export const translationGetSupportedTranslationLanguages = (language: string, signal?: AbortSignal) => {
  return customAxiosInstance<TranslationControllerTranslationLanguage[]>({
    url: `/api/v3/Translation/languages/${language}`,
    method: 'GET',
    signal
  });
};

export const getTranslationGetSupportedTranslationLanguagesQueryKey = (language?: string) => {
  return [`/api/v3/Translation/languages/${language}`] as const;
};

export const getTranslationGetSupportedTranslationLanguagesQueryOptions = <
  TData = Awaited<ReturnType<typeof translationGetSupportedTranslationLanguages>>,
  TError = unknown
>(
  language: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof translationGetSupportedTranslationLanguages>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTranslationGetSupportedTranslationLanguagesQueryKey(language);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof translationGetSupportedTranslationLanguages>>> = ({
    signal
  }) => translationGetSupportedTranslationLanguages(language, signal);

  return { queryKey, queryFn, enabled: !!language, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof translationGetSupportedTranslationLanguages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TranslationGetSupportedTranslationLanguagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof translationGetSupportedTranslationLanguages>>
>;
export type TranslationGetSupportedTranslationLanguagesQueryError = unknown;

export function useTranslationGetSupportedTranslationLanguages<
  TData = Awaited<ReturnType<typeof translationGetSupportedTranslationLanguages>>,
  TError = unknown
>(
  language: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof translationGetSupportedTranslationLanguages>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTranslationGetSupportedTranslationLanguagesQueryOptions(language, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const translationTranslateTo = (translationRequest: TranslationRequest, signal?: AbortSignal) => {
  return customAxiosInstance<TranslationControllerTranslatedAudioResult>({
    url: `/api/v3/Translation/translateTo`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: translationRequest,
    signal
  });
};

export const getTranslationTranslateToMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof translationTranslateTo>>,
    TError,
    { data: TranslationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof translationTranslateTo>>,
  TError,
  { data: TranslationRequest },
  TContext
> => {
  const mutationKey = ['translationTranslateTo'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof translationTranslateTo>>,
    { data: TranslationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return translationTranslateTo(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TranslationTranslateToMutationResult = NonNullable<Awaited<ReturnType<typeof translationTranslateTo>>>;
export type TranslationTranslateToMutationBody = TranslationRequest;
export type TranslationTranslateToMutationError = unknown;

export const useTranslationTranslateTo = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof translationTranslateTo>>,
    TError,
    { data: TranslationRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof translationTranslateTo>>,
  TError,
  { data: TranslationRequest },
  TContext
> => {
  const mutationOptions = getTranslationTranslateToMutationOptions(options);

  return useMutation(mutationOptions);
};
